import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Facebook = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path
      d="M22.8533 32V19.836h4.3242l.6475-4.7405h-4.9717V12.069c0-1.3725.4037-2.3078 2.4881-2.3078L28 9.7602v-4.24c-.4598-.0578-2.038-.1869-3.874-.1869-3.8332 0-6.4574 2.2092-6.4574 6.2662v3.496h-4.3353v4.7405h4.3353V32H1.7662C.7904 32 0 31.209 0 30.2337V1.7661C0 .7906.7906 0 1.7662 0H30.234C31.2093 0 32 .7906 32 1.7661v28.4676C32 31.2092 31.2092 32 30.234 32h-7.3807z"
      fillRule="nonzero"
    />
  </SvgIcon>
);

export default Facebook;
